export default "__VITE_ASSET__cAt9JfGz__"